import React from 'react';
import { Navigate, Link } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import ExecutiveDashboardPage from '@/pages/dashboards/ExecutiveDashboardPage';
import { ShieldCheck, ArrowRight } from 'lucide-react';
import { roleLabel } from '@/lib/roleLabels';

// Day 15 — /dashboard for every admin-shell role. Roles with `dashboard.view` get the executive dashboard;
// custom read-only roles (e.g. "Audit Manager") land on their first permitted module instead of a blank page.
const LANDINGS = [
  { permission: 'audit_registers.view', route: '/audit/registers', label: 'Audit Registers' },
  { permission: 'readiness.view', route: '/audit/readiness', label: 'NDIS Audit Readiness' },
  { permission: 'participants.view', route: '/participants/list', label: 'Participants' },
  { permission: 'roster.view', route: '/roster/scheduling-board', label: 'Scheduling Board' },
  { permission: 'incidents.view', route: '/compliance/incidents', label: 'Incidents' },
  { permission: 'restrictive_practices.view', route: '/compliance/restrictive-practices', label: 'Restrictive Practices' },
  { permission: 'forms.view', route: '/forms/templates', label: 'Form Templates' },
  { permission: 'engagement.feedback.view', route: '/engagement/feedback', label: 'Feedback' },
  { permission: 'invoices.view', route: '/finance/invoices', label: 'Invoices' },
];

export default function DashboardLanding() {
  const { user, hasPermission } = useAuth();
  if (hasPermission('dashboard.view')) return <ExecutiveDashboardPage />;
  const allowed = LANDINGS.filter(l => hasPermission(l.permission));
  if (allowed.length) return <Navigate to={allowed[0].route} replace />;
  return (
    <div className="max-w-xl mx-auto mt-16 rounded-lg border bg-white p-8 space-y-3" data-testid="dashboard-landing-empty">
      <ShieldCheck className="w-8 h-8 text-slate-500" />
      <h1 className="text-xl font-semibold">No landing page for your role</h1>
      <p className="text-sm text-muted-foreground">
        Your role <span className="font-medium">{roleLabel(user?.role_name)}</span> has no module permissions that map to a start page.
        Ask an administrator to grant permissions in <Link to="/admin/roles" className="underline">Roles</Link>.
      </p>
      <p className="text-xs text-muted-foreground flex items-center gap-1">Permissions load at sign-in — sign out and back in after changes <ArrowRight className="w-3 h-3" /></p>
    </div>
  );
}
